import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Auth } from '../services/auth/auth';
import { inject } from '@angular/core';
import { USE_OTP_API } from './api.context';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { catchError, throwError } from 'rxjs';
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
const auth = inject(Auth);
  const router = inject(Router);

  // 1. Context-Based Targeting
  const useOTPApi = req.context.get(USE_OTP_API);

  // Cleaned routing logic mapping directly to your environment schema keys
  const baseUrl = useOTPApi
    ? environment.otp?.otp_base_url
    : environment.nihs?.api_base_url; // 👈 Defaults directly to the primary NIHS API url

  // Safety protection fallback to prevent broken literal interpolation strings
  const finalBaseUrl = baseUrl || '';

  // 2. Authentication Token Security Handling
  const token = localStorage.getItem('authToken');

  // 3. Request Header Splitting & Payload Boundaries Packaging
  const isFormData = req.body instanceof FormData;
  const headers: Record<string, string> = {
    'Accept': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  // Keep FormData parameters clean to enable file binary uploads safely
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  const apiReq = req.clone({
    url: `${finalBaseUrl}${req.url}`,
    setHeaders: headers
  });

  // 4. Unified Error Tracking & Reporting Array Pipe
  return next(apiReq).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unexpected error occurred';

      if ([401, 403].includes(error.status)) {
        errorMessage = 'Session expired. Please login again.';
        auth.logout();
        router.navigate(['/login']);
      } else {
        errorMessage = extractErrorMessage(error.error);
      }

      return throwError(() => error);
    })
  );
};

function extractErrorMessage(errorBody: any): string {
  if (errorBody?.message) {
    return errorBody.message;
  }
  const errors = errorBody?.errors;
  if (errors && typeof errors === 'object') {
    for (const value of Object.values(errors)) {
      if (Array.isArray(value) && value.length > 0) {
        return String(value[0]);
      }
      if (typeof value === 'string' && value.trim()) {
        return value;
      }
    }
  }
  return 'An unexpected error occurred';
}
